import service from "@/utils/service"

//获取询盘总数
export function getInquiryCount() {
  return service({
    url: "/inquiry/info/getCount",
    method: "get"
  })
}

//获取echarts图表数据
export function getChartData() {
  return service({
    url: "/inquiry/info/getChartData",
    method: "get"
  })
}
